import React, { useRef, useEffect } from 'react'
import { CanvasSpace, Create, World, Particle, Num, Pt } from 'pts'

// Component
const Banner = () => {
  let banner = useRef(null)

  const createBanner = () => {
    // To vary ball size on smaller screens
    let pageWidth = undefined
    if (window.visualViewport) {
      pageWidth = window.visualViewport.width
    } else {
      pageWidth = window.innerWidth
    }
    // Creating space, form, points and colors
    let space = new CanvasSpace(banner)
    space.setup({ bgcolor: '#100c08' })
    space.autoResize = true
    let form = space.getForm()

    let world = new World(space.innerBound, 1, 0)

    space.add({
      start: (bound, space) => {
        let pts = Create.distributeRandom(
          space.innerBound,
          Math.round(pageWidth / 50) > 20 ? Math.round(pageWidth / 50) : 20
        )

        // Create particles and hit them with a random impulse
        for (let i = 0, len = pts.length; i < len; i++) {
          let p = new Particle(pts[i]).size(
            i === 0
              ? 30
              : pageWidth < 768
              ? 3 + (Math.random() * space.size.x) / 20
              : 3 + (Math.random() * space.size.x) / 35
          )
          p.hit(Num.randomRange(-30, 30), Num.randomRange(-20, 20))
          world.add(p)
        }

        world.particle(0).lock = true // lock it to move it by pointer later on
      },

      animate: (time, ftime) => {
        world.drawParticles((p, i) => {
          let color =
            i === 0
              ? '#fff'
              : ['#ff2d5d', '#42dc8e', '#cce6ff', '#ffe359'][i % 4]
          form.fillOnly(color).point(p, p.radius, 'circle')
        })

        world.update(ftime)
      },

      action: (type, px, py) => {
        if (type == 'move') {
          world.particle(0).position = new Pt(px, py)
        }
      },

      resize: (bound, evt) => {
        if (world) world.bound = space.innerBound
      },
    })

    // Bind the mouse for interactivity, and start animation
    space
      .bindMouse()
      .bindTouch()
      .play()
  }

  // Set initial width and draw canvas
  useEffect(() => {
    createBanner()
  })

  return (
    <div className="space-banner">
      <canvas ref={el => (banner = el)} />
    </div>
  )
}

export default Banner
